/**
 * Internal pilot-leads dashboard at /org/platform-admin/pilot-dashboard.
 *
 * Platform-admin only (server enforces via requirePlatformAdmin). Rendered
 * inside OrgAdminLayout. Tabs: Overview / Visitors / Visitor detail.
 */

import React, {useState} from 'react';
import {Box, Container, Tab, Tabs, Typography} from '@mui/material';
import {useDocumentTitle} from '../hooks/useDocumentTitle';
import PilotDashboardOverview from '../components/pilot-dashboard/PilotDashboardOverview';
import PilotVisitorTable from '../components/pilot-dashboard/PilotVisitorTable';
import PilotVisitorDetail from '../components/pilot-dashboard/PilotVisitorDetail';

type TabKey = 'overview' | 'visitors';

export default function PilotDashboardPage() {
  useDocumentTitle('Platform Admin · Pilot dashboard');
  const [tab, setTab] = useState<TabKey>('overview');
  const [selectedVisitorId, setSelectedVisitorId] = useState<string | null>(
    null,
  );

  return (
    <Box sx={{flex: 1, bgcolor: 'background.default'}}>
      <Container maxWidth="lg" sx={{py: 4}}>
        <Typography variant="h5" sx={{fontWeight: 600}}>
          Platform Admin · Pilot dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
          Visits, engagement, and conversions on the Paper Engineering /pilot
          page. Sourced from pilot_visitors / pilot_sessions / pilot_events /
          pilot_leads — backed by the daily pilot_aggregates rollup for the
          overview KPIs.
        </Typography>

        <Tabs
          value={tab}
          onChange={(_, v) => {
            setTab(v);
            setSelectedVisitorId(null);
          }}
          sx={{mt: 3, borderBottom: 1, borderColor: 'divider'}}
        >
          <Tab value="overview" label="Overview" />
          <Tab value="visitors" label="Visitors" />
        </Tabs>

        <Box sx={{mt: 3}}>
          {tab === 'overview' && <PilotDashboardOverview />}
          {tab === 'visitors' &&
            (selectedVisitorId ? (
              <PilotVisitorDetail
                visitorId={selectedVisitorId}
                onBack={() => setSelectedVisitorId(null)}
              />
            ) : (
              <PilotVisitorTable onSelect={(id) => setSelectedVisitorId(id)} />
            ))}
        </Box>
      </Container>
    </Box>
  );
}
